import { Element, Toast } from '@chaysehartsuff/active-html';
import PublishedBlog from '../../models/PublishedBlog.js';

export default class BlogPreview extends Element {

    /**
     * @type {Element}
     */
    publishButton;

    /**
     * @type {PublishedBlog}
     */
    blog;

    constructor(blogId, elementId) {
        super();
        this.blog = new PublishedBlog();
        this.blog.id = blogId;
        this.blog.get({}, (response) => {
            console.log('Blog preview data:', response);
            if(response.hasOwnProperty('model')) {
                let statusString = "Available ";
                if(this.isDateInFuture(response.model.publish_date)) {
                    statusString += `on <span class="font-bold">${this.getNiceDate(response.model.publish_date)}</span>`;
                } else {
                    statusString += "<span class=\"font-bold\">immediately</span>";
                }
                this.actionText = new Element().addContent(this.blog.is_published ? 'Unpublish' : 'Publish').addClass('min-w-[3rem] text-center cursor-pointer hover:text-blue-300 transition-colors');
                this.statusText = new Element().addContent(statusString);
                this.publishButton = new Element()
                .addContent( new Element().addContent(this.actionText).addClass('cursor-pointer text-md px-14 py-2 hover:bg-blue-800 transition-colors')
                   
                )
                .addContent(
                    new Element()
                        .addContent(this.statusText)
                        .addClass('text-center text-xs px-2 py-1 italic text-white bg-gray-700 ')
                )
                .addClass(' cursor-pointer fixed bottom-0 right-0 hover:bg-gray-700')
                .setStyle('background-color', '#175ba8')
                .setStyle('color', 'white')
                .onEvent('click', this.publishPreview.bind(this))
                ;
                this.addContent(this.publishButton);
            }
        });

        if (elementId){
            this.setId(elementId);
            this.bindAll();
        }
    }

    publishPreview(){
        if(this.blog.is_published) {
            this.blog.is_published = false;
        } else {
            this.blog.is_published = true;
        }
        this.blog.update({}, (response) => {
            console.log('Publish response:', response);
            if(this.blog.is_published) {
                this.actionText.setContent('Unpublish');
                new Toast('<a href="/blog/view/' + response.model.blog_id + '">Published! View Blog</a>').success();
            } else {
                this.actionText.setContent('Publish');
            }
            this.publishButton.removeClass('cursor-pointer hover:bg-blue-800').addClass('cursor-default bg-gray-700');
        });
    }

    getNiceDate(dateString) {
        if (!dateString) return 'No date';
        
        // Appending the time forces JS to parse this as local time instead of UTC midnight
        const date = new Date(dateString + 'T00:00:00');
        
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString(undefined, options);
    }

    isDateInFuture(dateString) {
        const now = new Date();
        const date = new Date(dateString);
        return date > now;
    }
}